import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

const ScreenContext = createContext();

export { ScreenContext };
class Screen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: [],
      expandedIndex: 0,
    };
    this.expandNextSection = this.expandNextSection.bind(this);
    this.collapseSection = this.collapseSection.bind(this);
  }

  componentDidMount() {
    this.initializeExpanded();
  }

  initializeExpanded() {
    const { children } = this.props;
    const e = [];
    for (let i = 0; i < children.length - 1; i += 1) {
      e[i] = 0;
    }
    this.setState({
      expanded: e,
    });
  }

  expandNextSection(i) {
    const { expanded, expandedIndex } = this.state;
    const expandedCopy = expanded;
    expandedCopy[i + 1] = 1;
    this.setState({
      expandedIndex: expandedIndex + 1,
      expanded: expandedCopy,
    });
  }

  collapseSection(i) {
    const { expanded } = this.state;
    const expandedCopy = expanded;
    expandedCopy[i] = 0;
    this.setState({
      expanded: expandedCopy,
    });
  }

  render() {
    const { children, index } = this.props;
    const { expanded } = this.state;
    let nullCount = 0;
    const childrenWithContext = React.Children.map(children, (child, i) => {
      let isLastSection = true;
      if (Array.isArray(children)) {
        isLastSection = i === children.length - 1;
      }
      if (!child) {
        nullCount += 1;
      }
      return (
        <ScreenContext.Provider
          value={{
            expanded: expanded[i - nullCount] === 1,
            expandedIndex: i,
            expandNextSection: this.expandNextSection,
            collapseSection: this.collapseSection,
            index,
            isLastSection,
          }}
        >
          {child}
        </ScreenContext.Provider>
      );
    });
    return <div className="questionnaire-screen">{childrenWithContext}</div>;
  }
}

Screen.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
};

export default Screen;
